import {
  Text,
  SequenceMenu,
  SequenceMenuItemType,
  Flex
} from '@sequencehq/core-components'
import { Primary14SemiBold } from '@sequencehq/core-components'

export const SavedViewTitle = ({
  title,
  kebabMenuItems
}: {
  title: string
  kebabMenuItems: SequenceMenuItemType[] | undefined
}) => {
  return (
    <Flex gap="8px" alignItems="center">
      <Text {...Primary14SemiBold}>{title}</Text>
      {kebabMenuItems && (
        <SequenceMenu
          data-testid="savedViews.title.kebabMenu"
          variant="ghost"
          items={kebabMenuItems}
          width={195}
          alignment="bottom-right"
        />
      )}
    </Flex>
  )
}
